// ─────────────────────────────────────────────────────────────────────────────
// icons.js — the small line icons used inside the node detail modal (featured
// overview cards + the SYSTEM METRICS rows). Each is a stroked glyph that
// inherits `currentColor`, so colour/size are controlled entirely by CSS.
// The `ICONS` map lets tabs look a glyph up by the key stored in the view-model.
// ─────────────────────────────────────────────────────────────────────────────
const base = {
  width: 16,
  height: 16,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.7,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

export const PulseIcon = () => (
  <svg {...base}>
    <path d="M3 12h4l2-6 4 12 2-6h6" />
  </svg>
);

export const ShieldIcon = () => (
  <svg {...base}>
    <path d="M12 2l8 3v6c0 5-3.5 8.5-8 11-4.5-2.5-8-6-8-11V5l8-3z" />
  </svg>
);

export const CpuIcon = () => (
  <svg {...base}>
    <rect x="6" y="6" width="12" height="12" rx="2" />
    <rect x="9" y="9" width="6" height="6" rx="1" />
    <path d="M9 2v2M15 2v2M9 20v2M15 20v2M2 9h2M2 15h2M20 9h2M20 15h2" />
  </svg>
);

export const MemoryIcon = () => (
  <svg {...base}>
    <rect x="2" y="7" width="20" height="10" rx="2" />
    <path d="M6 7v-.5M10 7v-.5M14 7v-.5M18 7v-.5M6 17v2M18 17v2" />
  </svg>
);

export const WifiIcon = () => (
  <svg {...base}>
    <path d="M2 8.5a16 16 0 0120 0M5 12a11 11 0 0114 0M8.5 15.5a6 6 0 017 0" />
    <circle cx="12" cy="19" r="0.6" fill="currentColor" stroke="none" />
  </svg>
);

// Larger empty-state shield (Alerts tab).
export const ShieldLargeIcon = () => (
  <svg {...base} width="34" height="34" strokeWidth="1.4">
    <path d="M12 2l8 3v6c0 5-3.5 8.5-8 11-4.5-2.5-8-6-8-11V5l8-3z" />
  </svg>
);

export const ICONS = {
  pulse: PulseIcon,
  shield: ShieldIcon,
  cpu: CpuIcon,
  memory: MemoryIcon,
  wifi: WifiIcon,
};
